import requestInstance from '../../utils/requestInstance';

const state = {
  selectedIPs: [], // temporary array for user interaction. once user confirmed, update the selectedIPs array
  confirmedSelectedIPs: [],
  submitted: false,
  submitting: false
};

const getters = {
  selectedIPs: state => {
    return state.selectedIPs;
  },
  confirmedSelectedIPs: state => {
    return state.confirmedSelectedIPs;
  },
  submitted: state => {
    return state.submitted;
  },
  submitting: state => {
    return state.submitting;
  }
};

const mutations = {
  setSelectedIPs: (state, selectedIPs) => {
    const set = new Set();
    selectedIPs.forEach(i => set.add(i));
    state.selectedIPs = [...set];
  },
  setConfirmSelected: state => {
    state.confirmedSelectedIPs = [...state.selectedIPs];
  },
  setSubmitted: (state, submitted) => {
    state.submitted = submitted;
    if (!submitted) {
      state.confirmedSelectedIPs = [];
    }
  },
  setSubmitting: (state, submitting) => {
    state.submitting = submitting;
  },
  clearConfirmSelected: state => {
    state.confirmedSelectedIPs = [];
  }
};

const actions = {
  submitForm: ({ rootState, state, commit, dispatch }, { message }) => {
    const data = {
      message,
      prefixes: state.confirmedSelectedIPs,
      username:
        rootState.authStore.user.nickname ||
        rootState.authStore.user.name ||
        '',
      account: rootState.dataStore.selectedAccount.account,
      asn: 'AS' + rootState.dataStore.selectedASN.id,
      timespan:
        'from ' +
        rootState.dataStore.startAndEndDate.current.start +
        ' to ' +
        rootState.dataStore.startAndEndDate.current.end.format('YYYY-MM-DD')
    };
    commit('setSubmitting', true);
    commit('setIsShowErrorInfoBanner', false, { root: true });

    requestInstance
      .post('/ticket', data)
      .then(res => {
        commit('setSubmitted', true);
        commit('setSubmitting', false);
      })
      .catch(e => {
        console.error(e);
        commit('setSubmitting', false);
        dispatch('setErrorInfoBanner', '', { root: true });
      });
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
